import type { JSX } from 'react';
import React from 'react';

import * as styles from './ScoutBadge.css';

/**
 * Fixed-position build-identity badge; renders only in scout preview builds
 * (non-empty PUBLIC_PATH_PREFIX) so reviewers always know which sha they are
 * testing.
 */
function ScoutBadge(): JSX.Element | null {
  if (!PUBLIC_PATH_PREFIX) {
    return null;
  }

  /*
   * Deliberately a raw <div> rather than Badge/Pill/Text from
   * @feathr/components: this is dev chrome overlaid on every page, not
   * product UI, and it must stay dependency-free so it can never be affected
   * by (or interfere with) the component library it exists to help test.
   */
  return <div className={styles.root}>🔭 {GIT_VERSION}</div>;
}

export default ScoutBadge;
